import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDashboardCount } from "../../redux/actions/DashboardActions";
import styled from "styled-components";
import moneyIcon from "../../images/money.png";
import CustomChartCard from "../../Components/CustomChart";
import CustomBarChart from '../../Components/CustomBarChart';
const Dashboard = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
  } = useSelector((state) => state);
  const {
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);

  useEffect(() => {
    dispatch(getDashboardCount(auth?.token));
  }, [auth.token]);
  const { dashboardCount } = useSelector((state) => state.dashboardReducer);

  const getSum = (arr) => {
    return arr?.reduce((prev, curr) => (prev += parseInt(curr.amount)), 0);
  };

  console.log(dashboardCount);

  return (
    <Wrapper>
      <div className="py-4">
        <div class="page-header pb-3">
          <h4 class="page-title">Merchant Dashboard</h4>
        </div>
        <div class="row pb-3">
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-center">
                  <div>
                    <h5 className="text-muted pb-2">
                      <b className="text-center">Visits </b>
                    </h5>
                  </div>
                  <h3 class="text-info fw-bold">
                    {dashboardCount?.consultantCount}
                  </h3>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <img src={moneyIcon} alt="Monthly Icon" className="money-icon" />
                  <h5 class="text-black mb-0 py-3 ">485</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-center">
                  <div>
                    <h5 className="text-muted pb-2">
                      <b className="text-center">Outlet Views</b>
                    </h5>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <img src={moneyIcon} alt="Monthly Icon" className="money-icon" />
                  <h5 class="text-black mb-0 py-3 fs-5">₹ 9852</h5>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-center">
                  <div>
                    <h5 className="text-muted pb-2">
                      <b className="text-center"> Reviews & Ratings </b>
                    </h5>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <img src={moneyIcon} alt="Monthly Icon" className="money-icon" />
                  <h5 class="text-black mb-0 py-3 fs-5">15</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-center">
                  <div>
                    <h5 className="text-muted pb-2">
                      <b>User Photo </b>
                    </h5>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <img src={moneyIcon} alt="Monthly Icon" className="money-icon" />
                  <h5 class="text-black mb-0 py-3 fs-5"> 25</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row row py-4 bg-white rounded">
          <div className="col-12 col-md-6 mb-3">
            <div className="mb-4">
              <h4 className="fw-bold text-dark">All Time Revenue</h4>
              <p className="text-muted mb-4">
                Line chart showing revenue for successful transaction for the selected periud
              </p>
            </div>
            <CustomChartCard />
          </div>
          <div className="col-12 col-md-6 mb-3">
            <div className="mb-4">
              <h4 className="fw-bold text-dark">Ticket Sales by Type</h4>
              <p className="text-muted mb-4">
                Bar chart comparing online vs counter ticket sales for the selected period.
              </p>
            </div>
            <CustomBarChart />
          </div>
        </div>
      </div>

    </Wrapper>
  );
};

export default Dashboard;

const Wrapper = styled.div`
  .b,
  .strong,
  b,
  strong {
    font-weight: 600 !important;
  }
  h3 {
    font-size: 1.1625rem;
  }
  h5 {
    font-size: 1.5rem !important;
    line-height: 1.4;
  }
  .fw-bold {
    font-weight: 600 !important;
  }
  .progress.progress-sm {
    height: 8px;
  }
  .bg-success {
    background-color: #35cd3a !important;
  }
  .text-success {
    color: #35cd3a !important;
  }
  .bg-danger {
    background-color: #f3545d !important;
  }
  .text-danger {
    color: #f3545d !important;
  }
  .bg-secondary {
    background-color: #716aca !important;
  }
  .text-secondary {
    color: #716aca !important;
  }

  .card-body w-100{
    width: fit-content;
    height: 150px;
  }
    .money-icon {
  width: 70px;
  object-fit: contain;
}

  
  @media (min-width: 750px) and (max-width:1440px) {
    h5{
      font-size: 20px !important;
    }
  }

  @media screen and (max-width:1070px) {
    h5{
      font-size: 15px !important;
     }
    p{
      font-size: .975rem !important;
    } 
  }

  
  
`;
